import React, { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';

import utils from '../../Helpers/FunctionsHelpers';
import strings from '../../Helpers/StringsHelpers';
import IssueClosureModalDocExpireModal from '../Custom/IssueClosureModalDocExpireModal';
import IssuesClosureModal from '../Custom/IssuesClosureModal';
import MassTreatmentModal from '../Custom/MassTreatmentModal';
import { SystemTypeIdDocsExpiration } from '../Enums/MaintenanceTypeIds';
import NCModal from '../Main/NCModal';
import Table from '../Table/Table';

import {
  getHeadquarters,
  getMaintenanceAll,
  getSystemTypes,
  getWarningList,
} from '../Api/Api';

export default function Ncs() {
  const { register, handleSubmit } = useForm();

  const defaultFilters = {
    name_unity: '',
    descrip: '',
    system: '',
    dt_created: '',
    status: '0',
    origin: '',
    headquarter: '',
    is_validated: 2,
    recurrence: true,
  };

  const [currentFilters, setCurrentFilters] = useState(defaultFilters);
  const [issues, setIssues] = useState([]);
  const [systemMaintenance, setSystemMaintenance] = useState([]);
  const [headquarters, setHeadquarters] = useState([]);
  const [headquarter_NC, setHeadquarter_NC] = useState('');
  const [systemTypes, setSystemTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [client_id, setClientId] = useState();
  const [origin_NC, setOrigin_NC] = useState('');
  const [useRecurrence, setUseRecurrence] = useState(true);
  const [show, setShow] = useState(false);
  const [showClosureDocExpireModal, setShowClosureDocExpireModal] =
    useState(false);
  const [warningList, setWarningList] = useState([]);
  const [showClosureModal, setShowClosureModal] = useState(false);
  const [selectedNCs, setSelectedNCs] = useState([]);
  const [showMassTreatmentModal, setShowMassTreatmentModal] = useState(false);

  const columns = [
    {
      title: 'NC',
      data: 'system_maintenance_id',
      className: 'text-center align-middle',
      with: '10%',
      render: (data, x, row) => {
        return 'NC - ' + data.toString().padStart(5, '0');
      },
    },
    {
      title: 'Unidade',
      data: 'organization_name',
      className: 'align-middle',
      width: '30%',
      render: (data, x, row) => {
        return `${row.info_name}`;
      },
    },
    {
      title: 'Sistema',
      data: 'system_type_name',
      className: 'align-middle',
    },
    {
      title: 'Problema',
      data: 'maintenance_type_name',
      className: 'align-middle',
      width: '40%',
    },
    {
      title: 'Data de criação',
      data: 'system_maintenance_created',
      className: 'text-center align-middle',
    },
    {
      title: 'Prazo sugerido',
      data: 'system_maintenance_expiration',
      className: 'text-center align-middle',
    },
    {
      title: 'Origem',
      data: 'inspection_id',
      className: 'text-center align-middle',
      render: (data, x, row) => {
        let title = 'Painel';
        let iconClass = `bi bi-grid`;

        if (data) {
          title = 'Aplicativo';
          iconClass = `bi bi-phone`;
        }
        return `<div class="icon-with-text"><i class="${iconClass}"></i> <span class="icon-text">${title}</span></div>`;
      },
    },
    {
      title: 'Status',
      data: 'situation_id',
      className: 'text-center align-middle',
      render: (data, x, row) => {
        let statusColor = 'badge bg-success';
        let statusName = 'Aberto';

        if (row.system_maintenance_concluded != null) {
          statusColor = 'badge bg-danger';
          statusName = 'Fechado';
        }

        return `<span class="${statusColor}">${statusName}</span>`;
      },
    },
    {
      title: 'Responsabilidade',
      data: 'is_responsable_s2u',
      className: 'text-center align-middle',
      width: '10%',
      render: (data, x, row) => {
        let badgeColor = 'secondary';
        let badgeTitle = 'Cliente';

        if (data === '1') {
          badgeColor = 'danger';
          badgeTitle = 'SAFETY2U';
        }

        return `<span class="badge rounded-pill bg-${badgeColor} pr-7" title=${badgeTitle}>&nbsp;</span>`;
      },
    },
    {
      title: 'Ações',
      data: null,
      className: 'text-center align-middle',
    },
  ];

  const actionButtons = (row) => {
    const anySelected = selectedNCs.length > 0;
    return (
      <>
        <button
          className={`btn btn-sm btn-primary m-2 treating ${anySelected ? 'disabled' : ''}`}
          onClick={(e) => {
            if (anySelected) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            handleShow(row);
          }}
          disabled={anySelected}
          title={
            anySelected
              ? 'Desmarque os itens selecionados para habilitar este botão'
              : 'Tratativas'
          }
        >
          Tratativas
        </button>
        <button
          type="btn"
          className="btn btn-sm btn-danger pl-1 pr-1"
          onClick={() => handleEnd(row)}
        >
          Encerrar
        </button>
      </>
    );
  };

  const handleOrigin = (e) => {
    setOrigin_NC(e.target.value);
  };

  const handleHeadquarter = (e) => {
    setHeadquarter_NC(e.target.value);
  };

  const handleRecurrenceToggle = () => {
    setUseRecurrence(!useRecurrence);
  };

  const handleModalDocExpire = async () => {
    setShowClosureDocExpireModal(true);
  };

  const handleCloseModalDocExpire = () => {
    setIssues([]);
    populateIssues(currentFilters);
    setShowClosureDocExpireModal(false);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = async (row) => {
    setSystemMaintenance([]);
    setSystemMaintenance(row);
    const rst = await getWarningList(row.system_maintenance_id);
    if (rst) {
      setWarningList(rst.data);
    }
    setShow(true);
  };

  const handleEnd = async (row) => {
    await setSystemMaintenance(row);
    setClientId(row.client_id);
    if (SystemTypeIdDocsExpiration.includes(row.maintenance_type_id)) {
      handleModalDocExpire();
    } else {
      handleClosureModal();
    }
  };

  const handleClosureModal = async () => {
    setShowClosureModal(true);
  };

  const handleCloseClosureModal = () => {
    setIssues([]);
    populateIssues(currentFilters);
    setShowClosureModal(false);
  };

  const handleSelectionChange = (selectedIds) => {
    const selectedData = issues.filter((nc) =>
      selectedIds.includes(nc.system_maintenance_id)
    );

    const simplifiedData = selectedData.map((nc) => ({
      system_maintenance_id: nc.system_maintenance_id,
      system_type_id: nc.system_type_id,
    }));

    setSelectedNCs(simplifiedData);
  };

  const handleShowMassTreatmentModal = (selectedIds) => {
    let dataToUse;

    if (selectedIds && selectedIds.length > 0) {
      dataToUse = issues
        .filter((nc) => selectedIds.includes(nc.system_maintenance_id))
        .map(({ system_maintenance_id, system_type_id }) => ({
          system_maintenance_id,
          system_type_id,
        }));
    }

    if (dataToUse.length > 0) {
      const hasControlePrazos = dataToUse.some(
        (nc) => nc.system_type_id === '15'
      );
      const hasOtherSystems = dataToUse.some(
        (nc) => nc.system_type_id !== '15'
      );

      if (hasControlePrazos && hasOtherSystems) {
        Swal.fire(
          'OPS!',
          "Não é possível realizar a tratativa em massa enquanto houverem NCs do tipo 'Controle de Prazos' misturados com outros tipos de sistemas na seleção",
          'error'
        );
        return;
      }

      setShowMassTreatmentModal(true);
    }
  };

  const handleCloseMassTreatmentModal = () => {
    setShowMassTreatmentModal(false);
  };

  const handleMassTreatmentSuccess = () => {
    setSelectedNCs([]);
    setIssues([]);
    populateIssues(currentFilters);
  };

  const listHeadquarters = async () => {
    const res = await getHeadquarters();
    setHeadquarters(res.data);
  };

  const listSystemsTypes = async () => {
    const res = await getSystemTypes();
    setSystemTypes(res.data);
  };

  const listMaintenanceAll = async () => {
    getMaintenanceAll(currentFilters)
      .then((res) => {
        if (res && res.data) {
          res.data.forEach((element) => {
            element.situation_id =
              element.system_maintenance_concluded != null
                ? 'Fechado'
                : 'Aberto';
            element.origem =
              element.inspection_id == null ? 'Painel' : 'Aplicativo';
          });
          setIssues(res.data);
        } else {
          setIssues([]);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(
          `${strings.OCORREU_UM_ERRO_AO_TENTAR_PROCESSAR_ESSA_REQUISICAO}: `,
          error
        );
        setIssues([]);
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const populateIssues = async (data) => {
    setIssues([]);
    setIsLoading(true);

    try {
      const mergedFilters = Object.keys(defaultFilters).reduce((acc, key) => {
        acc[key] = data[key] || defaultFilters[key];
        return acc;
      }, {});

      mergedFilters.recurrence = useRecurrence;

      setCurrentFilters(mergedFilters);
      const postData = mergedFilters;

      const res = await getMaintenanceAll(postData);

      if (res && res.data) {
        res.data.forEach((element) => {
          element.situation_id =
            element.system_maintenance_concluded != null ? 'Fechado' : 'Aberto';
          element.origem =
            element.inspection_id == null ? 'Painel' : 'Aplicativo';
        });
        setIssues(res.data);
      } else {
        setIssues([]);
      }
    } catch (error) {
      console.error(
        `${strings.OCORREU_UM_ERRO_AO_TENTAR_PROCESSAR_ESSA_REQUISICAO}: `,
        error
      );
      setIssues([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    utils.manageSidebar('close');
    listHeadquarters();
    listSystemsTypes();
    listMaintenanceAll();
  }, []);

  return (
    <>
      <main id="main" className="main">
        <section>
          <div className="card">
            <div className="card-header">
              <span>NCs (todas)</span>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit(populateIssues)}>
                <div className="row mt-2 mb-4">
                  <div className="col-sm-12 col-md-2">
                    <label>Unidade</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register('name_unity')}
                    />
                  </div>
                  <div className="col-sm-12 col-md-2">
                    <label>Descrição</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register('descrip')}
                    />
                  </div>
                  <div className="col-sm-12 col-md-2">
                    <label>Sistema</label>
                    <select
                      className="form-select"
                      id="system"
                      {...register('system')}
                    >
                      <option value="">Todos</option>
                      {systemTypes.length > 0 &&
                        systemTypes.map((item, index) => {
                          return (
                            <option key={index} value={item.system_type_id}>
                              {item.system_type_name}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                  <div className="col-sm-12 col-md-2">
                    <label>Data de criação</label>
                    <input
                      type="date"
                      className="form-control"
                      {...register('dt_created')}
                    />
                  </div>
                  <div className="col-sm-12 col-md-1">
                    <label>Origem</label>
                    <select
                      className="form-select"
                      value={origin_NC}
                      {...register('origin', {
                        onChange: (e) => {
                          handleOrigin(e);
                        },
                      })}
                    >
                      <option value="">Todos</option>
                      <option value="0">Painel</option>
                      <option value="1">Aplicativo</option>
                    </select>
                  </div>
                  <div className="col-sm-12 col-md-1">
                    <label>Gestão</label>
                    <select
                      className="form-select"
                      value={headquarter_NC}
                      {...register('headquarter', {
                        onChange: (e) => {
                          handleHeadquarter(e);
                        },
                      })}
                    >
                      <option value="">Selecione</option>
                      {headquarters.length > 0 &&
                        headquarters.map((item, index) => {
                          return (
                            <option key={index} value={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                  <div className="col-sm-12 d-flex align-items-end col-md-2">
                    <div className="d-flex w-100 gap-2">
                      <div className="d-flex flex-column align-items-center min-width-100">
                        <label className="mb-2">Recorrência</label>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input scale-input"
                            type="checkbox"
                            checked={useRecurrence}
                            onChange={handleRecurrenceToggle}
                          />
                        </div>
                      </div>
                      <div className="flex-fill d-flex align-items-end">
                        <button
                          className="btn py-1 btn-secondary btnFilter w-100"
                          type="submit"
                        >
                          {isLoading ? (
                            <div
                              className="spinner-border spinner-border-sm text-light"
                              role="status"
                            ></div>
                          ) : (
                            'Filtrar'
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <hr className="mb-4" />
              <div className="scrollAxis">
                <Table
                  data={issues}
                  columns={columns}
                  btnColumn={9}
                  actBtns={actionButtons}
                  keepState={true}
                  selectable={true}
                  useCheckboxes={true}
                  onSelectionChange={handleSelectionChange}
                  selectedRows={selectedNCs}
                  onBulkAction={handleShowMassTreatmentModal}
                />
              </div>
            </div>
          </div>
        </section>
        <IssuesClosureModal
          isOpen={showClosureModal}
          systemMaintenance={systemMaintenance}
          onClose={handleCloseClosureModal}
          client_id={client_id}
        />
        <IssueClosureModalDocExpireModal
          show={showClosureDocExpireModal}
          close={handleCloseModalDocExpire}
          system_maintenance_id={systemMaintenance?.system_maintenance_id}
          system_maintenance_created={
            systemMaintenance?.system_maintenance_created
          }
          client_id={client_id}
        />
        <NCModal
          show={show}
          handleClose={handleClose}
          userId={sessionStorage.getItem('gestao_userId')}
          systemMaintenance={systemMaintenance}
          warningList={warningList}
          setShow={setShow}
        />
        <MassTreatmentModal
          show={showMassTreatmentModal}
          handleClose={handleCloseMassTreatmentModal}
          selectedNCs={selectedNCs}
          onSuccess={handleMassTreatmentSuccess}
        />
      </main>
    </>
  );
}
